import { CALCULATOR_DATA } from './types';

export const urlParamToInputFieldMap: { [key: string]: keyof CALCULATOR_DATA } =
  {
    incomeSalary: 'TaxableSalary',
    exemptAllowances: 'ExemptIncome',
    interestIncome: 'InterestIncome',
    rentalIncome: 'RentalPropertyIncome',
    digitalAssets: 'DigitalAssetIncome',
    otherIncome: 'OtherIncome',
    loanSelf: 'OccupiedPropertyInterest',
    loanLetOut: 'RentalPropertyInterest',
    deduction80C: 'Section80C',
    deduction80D: 'Section80D',
    deduction80G: 'Section80G',
    deduction80EEA: 'Section80EEA',
    deduction80CCD: 'Section80CCD',
    deduction80CCD2: 'Section80CCD2',
    deduction80TTA: 'Section80TTA',
    otherDeduction: 'Section80E',
  };
